import React, { useState } from "react";
import styled from "styled-components";
import { useAuth } from "../context/auth";
import { navigate } from "@reach/router";
import { Initials, ImagePlacer2, Initials2 } from "./elements/Avatar";
const DropDownContainer = styled("div")`
  margin: 0 auto;
`;

const DropDownHeader = styled("div")`
  margin-bottom: 0.8em;
  font-weight: 500;
  font-size: 2vh;
  color: #fffcf2;
`;

const DropDownIcon = styled.img`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #fffcf2;
`;

const DropDownListContainer = styled("div")`
  position: absolute;
  z-index: 100;
  width: 10.5em;
`;

const DropDownList = styled("ul")`
  padding: 0;
  margin: 0;
  padding-left: 1em;
  background: #171111;
  border: 2px solid rgba(4, 3, 3, 0.2);
  border-radius: 10px;
  box-sizing: border-box;
  color: #fffcf2;
  font-size: 14px;
  font-weight: 500;
  &:first-child {
    padding-top: 0.8em;
  }
`;

const ListItem = styled("li")`
  list-style: none;
  margin-bottom: 0.8em;
  &:hover {
    color: #fd9e46;
  }
`;

export default function ProfileHeader() {
  const { user, Logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
  };
  const users = user;

  const openProfile = () => {
    navigate("/profile");
  };

  const getInitials = () => {
    const initials = user.data
      ? user.data.fullName.trim().split(" ")
      : user.fullName.trim().split(" ");
    if (initials.length === 1) return `${initials[0].charAt(0)}`;
    else
      return `${initials[0].charAt(0)}${initials[initials.length - 1].charAt(
        0
      )}`;
  };

  const short = getInitials();

  return (
    <DropDownContainer>
      <DropDownHeader onClick={toggling}>
        {user && user.data ? (
          <div>
            {user && user.data.avatar ? (
              <DropDownIcon src={users.data.avatar} />
            ) : (
              <ImagePlacer2>
                <Initials2>{short}</Initials2>
              </ImagePlacer2>
            )}
          </div>
        ) : (
          <div>
            {user && user.avatar ? (
              <DropDownIcon src={user.avatar} />
            ) : (
              <ImagePlacer2>
                <Initials2>{short}</Initials2>
              </ImagePlacer2>
            )}
          </div>
        )}
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer>
          <DropDownList>
            <ListItem onClick={openProfile}>My Profile</ListItem>
            <ListItem onClick={Logout}>Logout</ListItem>
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
}
